import request from '../../../request/request';

function loadResources(url) {
	return request({ url, method: 'GET', withCredentials: false, accept: 'json' }).then(({ body }) => body);
}

export default loadResources;
